module.exports = __webpack_public_path__ + "static/media/tetris.f6e8cdc2.jpg";